import { put } from "redux-saga/effects";
import { serverRequest, runEffect3Success } from "../../actions";
import get from "lodash/get";
/**
 * Send reques to execute/run an server-side effect.
 *
 * For document about the params, see runEffect3 action
 *
 */
export function* runEffect3(action) {
  const clientProps = get(action, "source.source", null);

  if (clientProps === "Params/client") {
    const result = get(action, "source.param", null);
    yield put(runEffect3Success({ data: result, effectId: action.effectId }));
    return;
  }

  // init & emit socket request
  const payload = {
    action: "runEffect3",
    source: action.source,
    props: action.props,
    effectId: action.effectId,
    applicationRef: action.applicationRef,
    context: action.context,
    pageId: action.pageId,
    pageType: action.pageType,
    componentId: action.componentId,
    clientStatus: action.clientStatus,
  };

  yield put(serverRequest(payload));
}

export default runEffect3;
